// Auth APIs
export const register = 'auth/register';
export const login = 'auth/login';
export const logout = 'auth/logout';
export const refresh = 'auth/refresh';

// Analytics APIs
export const userAnalytics = 'analytics/users/:userId';
export const assessmentAnalytics = 'analytics/assessments';
export const participationStats = 'analytics/participation';
export const systemInsights = 'analytics/system-insights';

// Assessments APIs
export const createAssessment = 'assessments/';
export const getAssessments = 'assessments/';
export const getAssessmentById = 'assessments/:id';
export const updateAssessment = 'assessments/:id';
export const addQuestion = 'assessments/questions';
export const randomTraitQuestion = 'assessments/randomTrait';
export const getAllQuestions = 'assessments/questions';
export const randomProjectiveQuestion = 'assessments/randomProjective';
export const updateQuestion = 'assessments/questions/:id';
export const getReAssessmentRequests = 'assessments/request';
export const updateReAssessmentRequest = 'assessments/request/:id';
export const importAssessments = "assessments/import";

// Feedback APIs
export const submitFeedback = 'feedback/';
export const getFeedback = 'feedback/';
export const respondFeedback = 'feedback/:id/respond';

// Logs APIs
export const activityLogs = 'logs/activity';
export const userActivityLogs = 'logs/activity/:userId';
export const auditLogs = 'logs/audit';
export const auditLogsByAction = 'logs/audit/action/:actionType';

// Notifications APIs
export const getNotifications = 'notifications/';
export const markNotificationAsRead = 'notifications/:id/read';
export const deleteNotification = 'notifications/:id';

// Prompts APIs
export const createCategory = 'prompts/categories';
export const getCategories = 'prompts/categories';
export const updateCategory = 'prompts/categories/:id';
export const createDataModal = 'prompts/dataModals';
export const getDataModals = 'prompts/dataModals';
export const updateDataModal = 'prompts/dataModals/:id';
export const createPrompt = 'prompts/';
export const getPrompts = 'prompts/';
export const updatePrompt = 'prompts/:id';
export const getPromptDetail = 'prompts/:id';
export const getReactionsForPrompt = 'prompts/:promptID/reactions';
export const getUserReaction = 'prompts/:promptID/reactions/:userID';
export const importPrompts = `prompts/import`

// Leaders APIs (root-mounted; not under /prompts)
export const getLeaders = 'leaders';
export const createLeader = 'leaders';
export const updateLeader = 'leaders/:id';
export const importLeadersCsv = 'leaders/import';
export const uploadLeaderImage = 'leaders/upload-image';
export const getProfileDashboards = 'profile-dashboards';
export const createProfileDashboard = 'profile-dashboards';
export const updateProfileDashboard = 'profile-dashboards/:id';

// User APIs
export const createUser = 'users/create';
export const getUsers = 'users/';
export const getDeletedUsers = 'users/deleted/list';
export const updateUser = 'users/:id';
export const getUserDetails = 'users/:id';
export const submitAnswer = 'users/answers';
export const getUserAnswers = 'users/answers';
export const getUserProgress = 'users/progress';
export const getUserResults = 'users/result';

// Email APIs
export const sendEmail = 'emails/send';
export const getEmailJobs = 'emails/jobs';


export const getRoles = 'roles'; 
export const createRole = 'roles'; 
export const updateRole = 'roles/:id';

export const getDashboardAnalytics = 'dashboard';

// Support Tickets
export const getSupportTickets = 'support';
export const updateSupportTicket = 'support/:id';
